// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    padding: 0;
    margin: 0;
    background-color: black;
    overflow: hidden;
}


.attribution {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: white;
    font: 12px Helvetica Neue, Arial, Helvetica, sans-serif;
    line-height: 12px;
    padding: 4px;
    z-index: 9;
}

#deck-wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}


#title {
    pointer-events:none;
    user-select: none;
    z-index: 9;
    height: 10em;
    position: relative;
    padding: 10px;
}

#title p {
    font-size: 40px;
    font-family: fantasy;
    font-kerning: none;
    margin: 0;
    background: linear-gradient(to right,
            black 50%,
            white 50% 100%);;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%)
}

#title p span{
    display: inline-block;
}

.black {
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,uBAAuB;IACvB,uDAAuD;IACvD,iBAAiB;IACjB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT;;2BAEuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["body {\n    padding: 0;\n    margin: 0;\n    background-color: black;\n    overflow: hidden;\n}\n\n\n.attribution {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background-color: white;\n    font: 12px Helvetica Neue, Arial, Helvetica, sans-serif;\n    line-height: 12px;\n    padding: 4px;\n    z-index: 9;\n}\n\n#deck-wrapper {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n}\n\n\n#title {\n    pointer-events:none;\n    user-select: none;\n    z-index: 9;\n    height: 10em;\n    position: relative;\n    padding: 10px;\n}\n\n#title p {\n    font-size: 40px;\n    font-family: fantasy;\n    font-kerning: none;\n    margin: 0;\n    background: linear-gradient(to right,\n            black 50%,\n            white 50% 100%);;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-right: -50%;\n    transform: translate(-50%, -50%)\n}\n\n#title p span{\n    display: inline-block;\n}\n\n.black {\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
